/* src/app/main/premium-data/wizard/steps/range-mapping/premium-data-row-selection.component.scss */
.input-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 30px;
}
.input-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.input-field label {
  font-weight: normal;
  min-width: 120px;
  white-space: nowrap;
  margin-right: 8px;
}
.input-field input {
  width: 160px;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
}
.input-field input:hover,
.input-field input:focus {
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
}
.data-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 100%;
  overflow-x: auto;
}
.data-preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
  border-radius: 10px;
  overflow: hidden;
  table-layout: fixed;
}
.data-preview-table tr {
  height: 40px;
  max-height: 40px;
  overflow: hidden;
}
.data-preview-table th,
.data-preview-table td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: center;
  max-width: 200px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  vertical-align: top;
  height: 40px;
  max-height: 40px;
  overflow: hidden;
  line-height: 1.2;
}
.data-preview-table thead tr {
  background-color: #006f8a;
  color: white;
  font-weight: bold;
}
.data-preview-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.data-preview-table tbody tr:nth-child(odd) {
  background-color: #fff;
}
.data-preview-table tr:hover {
  background-color: #e6f7ff;
}
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
.loading-indicator {
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 10px;
  height: 30px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.loading-indicator .spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #006f8a;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.data-preview-table tr {
  position: relative;
  transition: all 0.2s ease-in-out;
}
.data-preview-table tr.header-row {
  background:
    linear-gradient(
      90deg,
      rgba(220, 53, 69, 0.15),
      rgba(220, 53, 69, 0.08)) !important;
  border-left: 4px solid #dc3545;
  border-radius: 4px;
  color: #721c24 !important;
}
.data-preview-table tr.header-row td {
  color: #721c24 !important;
  font-weight: 500;
}
.data-preview-table tr.start-row {
  background:
    linear-gradient(
      90deg,
      rgba(40, 167, 69, 0.15),
      rgba(40, 167, 69, 0.08)) !important;
  border-left: 4px solid #28a745;
  border-radius: 4px;
  color: #155724 !important;
}
.data-preview-table tr.start-row td {
  color: #155724 !important;
  font-weight: 500;
}
.data-preview-table tr.end-row {
  background:
    linear-gradient(
      90deg,
      rgba(0, 123, 255, 0.15),
      rgba(0, 123, 255, 0.08)) !important;
  border-left: 4px solid #007bff;
  border-radius: 4px;
  color: #004085 !important;
}
.data-preview-table tr.end-row td {
  color: #004085 !important;
  font-weight: 500;
}
.data-preview-table tr.header-row td:first-child,
.data-preview-table tr.start-row td:first-child,
.data-preview-table tr.end-row td:first-child {
  position: relative;
}
.data-preview-table tr.header-row td:first-child::after {
  content: "HEADER";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: #dc3545;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  z-index: 10;
}
.data-preview-table tr.start-row td:first-child::after {
  content: "START";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: #28a745;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  z-index: 10;
}
.data-preview-table tr.end-row td:first-child::after {
  content: "END";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: #007bff;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  z-index: 10;
}
.header-row td::before,
.start-row td::before,
.end-row td::before {
  display: none;
}
/*# sourceMappingURL=premium-data-row-selection.component-YT4HUWYU.css.map */
